enum GoodsTypeEnum
{
    MOBILE_PHONE = "MOBILE_PHONE",
    NOTEBOOK = "NOTEBOOK",
    WATCH = "WATCH",
    TABLET = "TABLET",
    HEADPHONE = "HEADPHONE",
}

export default GoodsTypeEnum;
